module.exports = __webpack_public_path__ + "img/get-quote.95d8500e.jpeg";